var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"default_drag_comp"}},[_c('div',[_c('h4',[_vm._v("今天是 "+_vm._s(_vm.date))]),_c('span',[_vm._v(_vm._s(_vm.motto))])]),_c('img',{attrs:{"src":require("@/assets/images/steward.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }